/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */

/* eslint-disable @typescript-eslint/camelcase */
import React, { Fragment } from 'react'
import DistChart from './ChartComponents/Distribution'
import LinkIcon from './OutboundLinkComponent'
import PropTypes from 'prop-types'
import List from '../../../components/List'
import DownCarat from '../../../assets/icons/carat.svg'

class Nutrition extends React.Component {
  constructor(props) {
    super(props)

    // getinitialState
    this.state = {
      vegetables: this.Vegetables(),
      sugars: this.Sugars(),
      fiber: this.Fiber(),
      fruits: this.Fruits(),
      dairy: this.Dairy(),
      grains: this.Grains(),
      calcium: this.Calcium()
    }
  }

  UNSAFE_componentWillReceiveProps() {
    this.setState({
      vegetables: this.Vegetables(),
      sugars: this.Sugars(),
      fiber: this.Fiber(),
      fruits: this.Fruits(),
      dairy: this.Dairy(),
      grains: this.Grains(),
      calcium: this.Calcium()
    })
  }

  Vegetables() {
    const { details } = this.props
    let stats = details.vegetables

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  Sugars() {
    const { details } = this.props
    let stats = details.vegetables

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  Fiber() {
    const { details } = this.props
    let stats = details.fiber

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  Fruits() {
    const { details } = this.props
    let stats = details.fruits

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  Dairy() {
    const { details } = this.props
    let stats = details.dairy

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  Grains() {
    const { details } = this.props
    let stats = details.whole_grains

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  Calcium() {
    const { details } = this.props
    let stats = details.calcium

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  render() {
    const { details, index, hotload } = this.props

    const items = {
      physicalActivity: {
        title: '<h2 class="mobile-padding">Nutrition</h2>',
        icon: { src: DownCarat },
        isShowAccordianOnMobile: true,
        accordianContent: `
      <div class="mobile-padding">
            <div>
              <p class="noMarginPadding">
                Nutrition is assessed by the Dietary Screener Questionnaire (DSQ)
            developed by the CDC as part of the National Health and Nutrition
            Survey. This survey assesses food and drink intake to infer intake
            of specific dietary factors of interest.
              </p>
            </div>
            <br/>
          <div class="intro-title">
            Dietary Screener Questionnaire (DSQ)
              </div>
              <br/>
          </div>`
      }
    }
    const listProps = {
      items,
      isMobile: this.props.isMobile,
      isNoTopBorder: true,
      isNotSpacer: true,
      isCollapsedDark: true,
      isReportStyle: true
    }

    return (
      <div className="nutrition-content module-content">
        <div className="intro-zone">
          {this.props.isMobile ? (
            <List {...listProps} />
          ) : (
            <Fragment>
              <div className="intro-title">
                Dietary Screener Questionnaire (DSQ)
              </div>

              <p>
                Nutrition is assessed by the Dietary Screener Questionnaire
                (DSQ) developed by the CDC as part of the National Health and
                Nutrition Survey. This survey assesses food and drink intake to
                infer intake of specific dietary factors of interest.
              </p>
            </Fragment>
          )}
        </div>

        {hotload ? (
          <div className="mobile-padding">
            {!this.props.isMobile && <hr />}

            <div className="bucket">
              <div className="table">
                <div className="trow dominant">
                  <div className="td even-width">
                    <a
                      href="https://www.choosemyplate.gov/vegetables"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <strong className="subject">
                        {details.vegetables.display_label}
                      </strong>
                      <LinkIcon />
                    </a>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.vegetables.value}
                    </strong>
                    <span className="descriptor">
                      {details.vegetables.unit}
                    </span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.vegetables.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'Vegetables'}
                      details={details}
                      index={index}
                      data={this.state.vegetables}
                    />
                  </div>
                </div>
              </div>
              {!details.vegetables.__ok ? (
                <div className="no-report-data">
                  {`No ${details.vegetables.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <hr />
            <div className="bucket">
              <div className="table">
                <div className="trow nondominant">
                  <div className="td even-width">
                    <a
                      href="https://www.choosemyplate.gov/what-are-added-sugars"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <strong className="subject">
                        {details.added_sugars.display_label}
                      </strong>
                      <LinkIcon />
                    </a>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.added_sugars.value}
                    </strong>
                    <span className="descriptor">
                      {details.added_sugars.unit}
                    </span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.added_sugars.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'AddedSugars'}
                      details={details}
                      index={index}
                      data={this.state.sugars}
                    />
                  </div>
                </div>
              </div>

              {!details.added_sugars.__ok ? (
                <div className="no-report-data">
                  {`No ${details.added_sugars.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <hr />

            <div className="bucket">
              <div className="table">
                <div className="trow nondominant">
                  <div className="td even-width">
                    <a
                      href="http://www.mayoclinic.org/healthy-lifestyle/nutrition-and-healthy-eating/in-depth/fiber/art-20043983"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <strong className="subject">
                        {details.fiber.display_label}
                      </strong>
                      <LinkIcon />
                    </a>
                  </div>
                  <div className="td even-width">
                    <strong className="value">{details.fiber.value}</strong>
                    <span className="descriptor">{details.fiber.unit}</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.fiber.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'Fiber'}
                      details={details}
                      index={index}
                      data={this.state.fiber}
                    />
                  </div>
                </div>
              </div>
              {!details.fiber.__ok ? (
                <div className="no-report-data">
                  {`No ${details.fiber.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <hr />

            <div className="bucket">
              <div className="table">
                <div className="trow nondominant">
                  <div className="td even-width">
                    <a
                      href="https://www.choosemyplate.gov/fruit"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <strong className="subject">
                        {details.fruits.display_label}
                      </strong>
                      <LinkIcon />
                    </a>
                  </div>
                  <div className="td even-width">
                    <strong className="value">{details.fruits.value}</strong>
                    <span className="descriptor">{details.fruits.unit}</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.fruits.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'Fruits'}
                      details={details}
                      index={index}
                      data={this.state.fruits}
                    />
                  </div>
                </div>
              </div>
              {!details.fruits.__ok ? (
                <div className="no-report-data">
                  {`No ${details.fruits.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <hr />

            <div className="bucket">
              <div className="table">
                <div className="trow nondominant">
                  <div className="td even-width">
                    <a
                      href="https://www.choosemyplate.gov/dairy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <strong className="subject">
                        {details.dairy.display_label}
                      </strong>
                      <LinkIcon />
                    </a>
                  </div>
                  <div className="td even-width">
                    <strong className="value">{details.dairy.value}</strong>
                    <span className="descriptor">{details.dairy.unit}</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.dairy.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'Dairy'}
                      details={details}
                      index={index}
                      data={this.state.dairy}
                    />
                  </div>
                </div>
              </div>
              {!details.dairy.__ok ? (
                <div className="no-report-data">
                  {`No ${details.dairy.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <hr />

            <div className="bucket">
              <div className="table">
                <div className="trow nondominant">
                  <div className="td even-width">
                    <a
                      href="https://www.choosemyplate.gov/grains"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <strong className="subject">
                        {details.whole_grains.display_label}
                      </strong>
                      <LinkIcon />
                    </a>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.whole_grains.value}
                    </strong>
                    <span className="descriptor">
                      {details.whole_grains.unit}
                    </span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.whole_grains.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'WholeGrains'}
                      details={details}
                      index={index}
                      data={this.state.grains}
                    />
                  </div>
                </div>
              </div>
              {!details.whole_grains.__ok ? (
                <div className="no-report-data">
                  {`No ${details.whole_grains.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <hr />

            <div className="bucket">
              <div className="table">
                <div className="trow nondominant">
                  <div className="td even-width">
                    <a
                      href="https://medlineplus.gov/calcium.html"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <strong className="subject">
                        {details.calcium.display_label}
                      </strong>
                      <LinkIcon />
                    </a>
                  </div>
                  <div className="td even-width">
                    <strong className="value">{details.calcium.value}</strong>
                    <span className="descriptor">{details.calcium.unit}</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.calcium.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'Calcium'}
                      details={details}
                      index={index}
                      data={this.state.calcium}
                    />
                  </div>
                </div>
              </div>
              {!details.calcium.__ok ? (
                <div className="no-report-data">
                  {`No ${details.calcium.display_label} Data Available`}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

Nutrition.propTypes = {
  details: PropTypes.object.isRequired
}

export default Nutrition
